import template from "./scan_attendance.html";
import en from "./en.translation.json";
import es from "./es.translation.json";
import _ from "lodash";
import mixpanel from "mixpanel-browser";
import moment from "moment";
import { COMPLETE, GROWER_CERTIFIED, PENDING } from "../../safety.constants";
import { AttendanceBaseController } from "../controllers";
import { captureMessage } from "@sentry/browser";

class ScanAttendanceController extends AttendanceBaseController {
    /* @ngInject */
    constructor(
        TimeTrackingVendorConfigurationService,
        SafetyMeetingRequestService,
        $state,
        $q,
        $timeout,
        SignatureService,
    ) {
        super($state, $q, $timeout, SignatureService);
        this.TimeTrackingVendorConfigurationService =
            TimeTrackingVendorConfigurationService;
        this.SafetyMeetingRequestService = SafetyMeetingRequestService;
    }

    handleSuccess(value) {
        let ctrl = this;
        ctrl.showSpinner = true;
        ctrl.TimeTrackingVendorConfigurationService.find_grower_membership(
            value,
            ctrl.grower.sid,
        ).then(
            function (result) {
                if (ctrl.requiresSignature) {
                    ctrl.showSignature = true;
                    ctrl.showSpinner = false;
                    ctrl.userSid = result.user;
                } else {
                    ctrl.create(result.user, ctrl.meeting);
                }
            },
            function () {
                ctrl.showSpinner = false;
                ctrl.showFailureOverlay = true;
                ctrl.$timeout(function () {
                    ctrl.showFailureOverlay = false;
                }, ctrl.OVERLAY_TIMEOUT);
            },
        );
    }

    create(participant, meeting, signatureImageData) {
        let ctrl = this;
        return ctrl
            .getSignatureResponse(
                participant,
                signatureImageData,
                meeting.organizer,
            )
            .then(
                function (signature) {
                    let params = {
                        subject__sid: participant,
                        safety_meeting__sid: meeting.sid,
                    };
                    ctrl.SafetyMeetingRequestService.list(params).then(
                        function (existingRequests) {
                            let allRequests = _.map(
                                meeting.topics,
                                function (topic) {
                                    let existingRequest = _.find(
                                        existingRequests,
                                        ["topic", topic],
                                    );
                                    if (existingRequest) {
                                        if (
                                            existingRequest.status === PENDING
                                        ) {
                                            existingRequest.status = COMPLETE;
                                            existingRequest.completion_date =
                                                moment();
                                            existingRequest.certifier =
                                                ctrl.account.sid;
                                            existingRequest.certification_type =
                                                GROWER_CERTIFIED;
                                            return existingRequest.save();
                                        }
                                    } else {
                                        let newRequest = {
                                            subject: participant,
                                            safety_meeting: meeting.sid,
                                            requester: meeting.organizer,
                                            topic: topic,
                                            completion_date: moment(),
                                            status: COMPLETE,
                                            certifier: ctrl.account.sid,
                                            certification_type:
                                                GROWER_CERTIFIED,
                                        };
                                        if (signature) {
                                            newRequest.signature =
                                                signature.sid;
                                        }
                                        return ctrl.SafetyMeetingRequestService.create(
                                            newRequest,
                                        );
                                    }
                                },
                            );
                            ctrl.$q.all(allRequests).then(
                                function (data) {
                                    mixpanel.track(
                                        "Added participant through badge scanner",
                                        { company_sid: ctrl.grower.sid },
                                    );
                                    ctrl.showSignatureSpinner = false;
                                    ctrl.showSignature = false;
                                    ctrl.showSpinner = false;
                                    ctrl.showSuccessOverlay = true;
                                    ctrl.$timeout(function () {
                                        ctrl.showSuccessOverlay = false;
                                    }, ctrl.OVERLAY_TIMEOUT);
                                },
                                function (reason) {
                                    ctrl.showSignatureSpinner = false;
                                    ctrl.showSignature = false;
                                    ctrl.showSpinner = false;
                                    ctrl.showAlreadyExistsOverlay = true;
                                    ctrl.$timeout(function () {
                                        ctrl.showAlreadyExistsOverlay = false;
                                    }, ctrl.OVERLAY_TIMEOUT);
                                },
                            );
                        },
                        function () {
                            captureMessage(
                                "Failed to search for existing safety meeting requests for this user!",
                            );
                        },
                    );
                },
                function () {
                    captureMessage("Failed to create safety signature!");
                },
            );
    }
}
export default {
    controller: ScanAttendanceController,
    template: template,
    translations: { en, es },
    bindings: {
        workers: "<",
        grower: "<",
        meeting: "<",
        account: "<",
        topics: "<",
        redirectState: "<",
        manualState: "<",
    },
    name: "scanAttendance",
};
